export default __webpack_public_path__ + "media/partners-logos/1_Percent_Logo_@2x-7bfb8454.png";